import { FormattedMessage } from 'react-intl';

export const SelfManagedPeriodChip = () => (
  <span className="inline-flex w-fit shrink-0 rounded-full bg-background-200 px-2 py-0.5 text-sm font-medium text-text-800">
    <FormattedMessage defaultMessage="Hanterar egna perioder" />
  </span>
);
